import type { RecoveryAttemptState } from '../redux/features/recoveryAttemptSlice';

export type RecoveryBlock = {
  /** `lockout`: se llegó al tope de solicitudes; `retry`: falta el intervalo. */
  reason: 'lockout' | 'retry';
  secondsLeft: number;
};

type Params = {
  attempt: RecoveryAttemptState;
  now: number;
  lockoutSeconds: number;
  retryIntervalSeconds: number;
};

const secondsUntil = (from: number, seconds: number, now: number): number =>
  Math.ceil((from + seconds * 1000 - now) / 1000);

/**
 * Dice si la recuperación está bloqueada en este momento y cuánto falta. El
 * bloqueo por tope manda sobre el intervalo entre solicitudes. Devuelve `null`
 * cuando se puede enviar.
 */
export const getRecoveryBlock = ({
  attempt: { lastAttemptAt, lockedAt },
  now,
  lockoutSeconds,
  retryIntervalSeconds,
}: Params): RecoveryBlock | null => {
  if (lockedAt !== null) {
    const secondsLeft = secondsUntil(lockedAt, lockoutSeconds, now);
    if (secondsLeft > 0) return { reason: 'lockout', secondsLeft };
  }

  if (lastAttemptAt !== null) {
    const secondsLeft = secondsUntil(lastAttemptAt, retryIntervalSeconds, now);
    if (secondsLeft > 0) return { reason: 'retry', secondsLeft };
  }

  return null;
};

/** `600` → `10:00`; `75` → `1:15`. */
export const formatCountdown = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const rest = String(seconds % 60).padStart(2, '0');
  return `${minutes}:${rest}`;
};
